/* ==========================================================================
   MÓDULO: MODAL DE BÚSQUEDA - VERSIÓN CON TAGS ENLAZABLES
   ========================================================================== */

// Función de utilidad para convertir texto en un slug de URL
const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Reemplaza espacios con -
    .replace(/[^\w\-]+/g, "") // Elimina caracteres no alfanuméricos
    .replace(/\-\-+/g, "-"); // Reemplaza múltiples - con uno solo
};

// Función que busca los tags de Pagefind y los convierte en enlaces
const linkifyTags = (resultsContainer) => {
  const tags = resultsContainer.querySelectorAll(".pagefind-ui__result-tag");
  tags.forEach((tag) => {
    // Evita volver a enlazar un tag que ya es un enlace
    if (tag.tagName === "A") return;

    const tagText = tag.textContent;
    const tagSlug = slugify(tagText);
    const link = document.createElement("a");
    link.href = `/tags/${tagSlug}/`;
    link.className = tag.className; // Mantiene las clases de estilo
    link.textContent = tagText;

    // Reemplaza el span/div del tag con el nuevo enlace
    tag.parentNode.replaceChild(link, tag);
  });
};

export default function initSearchModal() {
  // ... (todo el código de selección de elementos y las funciones open/close se mantienen igual)
  const openButton = document.getElementById("search-open-button");
  const searchOverlay = document.getElementById("search-overlay");
  if (!openButton || !searchOverlay) return;
  // ... (etc.)

  // --- ¡MEJORA CLAVE! ---
  // Observamos el contenedor de resultados para actuar cuando Pagefind añada contenido.
  const resultsContainer = searchOverlay.querySelector(
    ".pagefind-ui__results-area",
  );
  if (resultsContainer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          // Cuando se añaden nuevos resultados, los enlazamos.
          linkifyTags(resultsContainer);
        }
      }
    });
    observer.observe(resultsContainer, { childList: true });
  }

  // --- ¡ACCIÓN DEFENSIVA CLAVE! ---
  // Al inicializar, nos aseguramos de que el modal esté en el estado CERRADO.
  // Esto previene cualquier condición de carrera en la carga de la página.
  searchOverlay.hidden = true;
  searchOverlay.inert = true;

  const closeButton = searchOverlay.querySelector(".modal__close-button");
  const searchContainerId = "#modal-search-container";
  let pagefindInstance = null;

  const openModal = () => {
    searchOverlay.hidden = false;
    document.body.classList.add("body-no-scroll");

    // Enfocamos el contenido del modal o el botón de cierre
    // Usamos un pequeño delay para asegurar que la transición CSS ha comenzado
    setTimeout(() => {
      searchOverlay.inert = false;
      closeButton?.focus();
    }, 10);

    if (!pagefindInstance) {
      try {
        // La inicialización ahora es más simple.
        // Pagefind usará el atributo 'data-pagefind-ui' que hemos añadido.
        pagefindInstance = new PagefindUI({
          element: "#modal-search-container",
          resetStyles: false,
          showSubResults: true,
          showImages: false,
          translations: {
            placeholder: "Buscar en el archivo...",
            zero_results: "No se encontraron resultados para '[SEARCH_TERM]'",
            many_results: "[COUNT] resultados encontrados para '[SEARCH_TERM]'",
            one_result: "[COUNT] resultado encontrado para '[SEARCH_TERM]'",
          },
        });
      } catch (e) {
        console.error("Error al inicializar PagefindUI.", e);
      }
    }
  };

  const closeModal = () => {
    openButton?.focus();
    searchOverlay.hidden = true;
    searchOverlay.inert = true;
    document.body.classList.remove("body-no-scroll");
  };

  // ... los event listeners se mantienen igual ...
  openButton.addEventListener("click", openModal);
  closeButton?.addEventListener("click", closeModal);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !searchOverlay.hidden) closeModal();
  });
  searchOverlay.addEventListener("click", (event) => {
    if (event.target === searchOverlay) closeModal();
  });
}
